import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { createAplicacionFertilizanteOfflineFirst } from '../../services/offline/syncQueueFertilizantes';
import { obtenerMisProductoresAsignados } from '../../services/productoresEncargado';
import AppShell from '../../components/layout/AppShell';
import FertilizanteForm from '../../components/fertilizantes/FertilizanteForm';

function NuevaFertilizantePage() {
  const { user, productor } = useAuth();
  const navigate = useNavigate();

  const [productores, setProductores] = useState([]);
  const [productoresStatus, setProductoresStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setProductoresStatus('loading');
    obtenerMisProductoresAsignados(user?.id).then((result) => {
      if (!active) return;
      if (result.ok) setProductores(result.productores);
      setProductoresStatus('ready');
    });
    return () => {
      active = false;
    };
  }, [user?.id]);

  const handleSubmit = async (payload) => {
    const result = await createAplicacionFertilizanteOfflineFirst(user.id, payload);

    if (result.ok && result.offline) {
      // Sin id de servidor todavía: no hay detalle al que ir, se vuelve al
      // listado, donde la tarjeta aparece como PENDIENTE DE SINCRONIZAR.
      navigate('/fertilizantes', { state: { justSavedOffline: true }, replace: true });
    } else if (result.ok) {
      navigate(`/fertilizantes/${result.id}`, { state: { justCreated: true }, replace: true });
    }

    return result;
  };

  return (
    <AppShell title="Nueva aplicación de fertilizantes">
      <FertilizanteForm
        productorNombre={productores[0]?.nombre || productor?.nombre}
        productores={productores}
        productoresStatus={productoresStatus}
        onSubmit={handleSubmit}
        cancelTo="/fertilizantes"
      />
    </AppShell>
  );
}

export default NuevaFertilizantePage;
